import { FuseRouteItemType } from "@fuse/utils/FuseUtils";
import { layoutConfigOnlyMain } from "@/configs/layoutConfigTemplates";
import ErrorPageView from "./components/ErrorPageView";

/**
 * The Error page routes.
 */
const route: FuseRouteItemType = {
	path: "",
	children: [
		{
			path: "401",
			element: <ErrorPageView sourcePage="401" />,
			settings: { layout: layoutConfigOnlyMain },
		},
		{
			path: "404",
			element: <ErrorPageView sourcePage="404" />,
			settings: { layout: layoutConfigOnlyMain },
			auth: null,
		},
	],
};

export default route;
